import{getYear}from"date-fns";export var getCentury=function(a){var b=getYear(a);return 0===b?0:0<b?100*Math.trunc(b/100):100*Math.floor(b/100)};
//# sourceMappingURL=getCentury.js.map